import { Link, Text, View } from "@react-pdf/renderer";
import React from "react";
import { SvgIconProps } from "../graphics/SvgIconProps";
import { color } from "../styles";
import QrCode from "../graphics/QrCode";

type InfoBoxProps = {
  title: string;
  description: string;
  qrData?: string;
  links: { icon?: React.FC<SvgIconProps>; url: string; label: string }[];
};

const InfoBox: React.FC<InfoBoxProps> = ({ title, description, qrData, links }) => {
  return (
    <View style={{ width: 230, height: 180, backgroundColor: color.lightGrey, padding: 20 }}>
      <Text style={{ fontWeight: "bold", marginBottom: 10, color: color.primary }}>{title}</Text>

      <Text style={{ fontSize: 12, marginBottom: 15, lineHeight: 1.3 }}>{description}</Text>

      {links.map(({ icon: Icon, url, label }) => (
        <View
          key={label}
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: 10,
            marginBottom: 5,
          }}
        >
          {Icon && (
            <Icon width={14} height={14} color={color.darkGrey} style={{ marginHorizontal: 5 }} />
          )}

          <Link src={url} style={{ fontSize: 12, color: color.black, marginBottom: 2 }}>
            {label}
          </Link>
        </View>
      ))}

      {qrData && (
        <QrCode
          text={qrData}
          width={40}
          height={40}
          fill={color.darkGrey}
          style={{ position: "absolute", bottom: 15, right: 15 }}
        />
      )}
    </View>
  );
};

export default InfoBox;
